import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { theme, headerHeight, breakpoints, lessThanLargeGutter } from '../ui-config.js'
import Signature from './Signature'
import Button from './Button'
import imgs from '../images'

const StyledHeader = styled.header`
    z-index: 1;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: ${theme.backgroundColor};
    height: ${headerHeight.default}px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;

    @media print {
        display: none;
    }

    @media (max-width: ${breakpoints.large}px) {
        padding-left: ${lessThanLargeGutter}px;
        padding-right: ${lessThanLargeGutter}px;
    }

    @media (max-width: ${breakpoints.small}px) {
        height: ${headerHeight.small}px;
        padding-right: 8px;
        padding-left: 0;
    }
`

const headerContentHeight = {
    default: headerHeight.default / 1.7,
    small: headerHeight.small / 1.7,
}

const Content = styled.div`
    margin: 0 auto;
    display: flex;
    width: ${breakpoints.large}px;
    height: ${headerContentHeight.default}px;

    @media (max-width: ${breakpoints.large+breakpoints.buffer}px) {
        max-width: 98%;
        padding: 0 1%;
    }

    @media (max-width: ${breakpoints.small}px) {
        height: ${headerContentHeight.small}px;
    }

`

const StyledLink = styled(Link)`
    & svg {
        height: ${headerContentHeight.default}px;

        @media (max-width: ${breakpoints.small}px) {
            height: ${headerContentHeight.small}px;
            margin-left: 10px;
        }
    }
`

const SocialLink = styled.a`
    margin-right: 16px;
    margin-top: 6px;
    & > img { height: 22px; }
`

const Left = styled.div`
    text-align: left;
    align-items: center;
    display: flex;
`

const Center = styled.div`
    flex: 1;
`

const Right = styled.div`
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const RightInner = styled.div`
    & > * {
        display: inline-block;
        vertical-align: middle;
    }
`

const StyledA = styled.a`
    text-decoration: none;
    width: 138px;

    @media (max-width: ${breakpoints.small}px) {
        width: 100px;
    }
`


export default class Header extends Component {
    render() {
        return (
            <StyledHeader>
                <Content>
                    <Left>
                        <StyledLink to="/">
                            <Signature />
                        </StyledLink>
                    </Left>
                    <Center />
                    <Right>
                        <RightInner>
                            <SocialLink href='https://www.linkedin.com/in/tyler-ross-martin/'>
                                <img alt="linkedin profile" src={imgs.linkedinMark} />
                            </SocialLink>
                            <SocialLink href='https://github.com/martinRoss'>
                                <img alt="github profile" src={imgs.githubMark} />
                            </SocialLink>
                            <StyledA href="https://docs.google.com/forms/d/e/1FAIpQLSfiGVYQE5juCNm9JytLkuupDg3_iBnvDeyc09KivEwxBdcnMA/viewform?usp=sf_link">
                                <Button style={{
                                    height: 36,
                                    width: '100%',
                                    color: theme.inverseText,
                                    backgroundColor: theme.action,
                                    border: `1px solid ${theme.action}`
                                }}>contact</Button>
                            </StyledA>
                        </RightInner>
                    </Right>
                </Content>
            </StyledHeader>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Header.js